"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareholderEditFormSchema = exports.ShareholderFormSchema = exports.ShareholderSchema = exports.IndividualShareholderSchema = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const yup = __importStar(require("yup"));
const enums_1 = require("../contracts/enums");
const Contact_1 = require("./Contact");
const MyStakeAddress_1 = require("./MyStakeAddress");
exports.IndividualShareholderSchema = yup.object().shape({
    legalEntityName: yup.string(),
    legalEntityAddresses: yup.array().of(yup.object().shape(Object.assign({}, MyStakeAddress_1.MyStakeAddressSchema))),
    contacts: yup.array().of(yup.object().shape(Object.assign({}, Contact_1.ContactSchema))),
});
const beneficiaryABNSchema = yup.lazy((value) => {
    if (value && value.length > 0) {
        return yup
            .string()
            .trim()
            .matches(/^[0-9\s]*$/, "ABN should contain only digits")
            .test("beneficiaryABN", "ABN should be 11 digits.", (beneficiaryABN) => {
            if (beneficiaryABN.replace(/\s/g, "").length === 0)
                return true;
            return beneficiaryABN.replace(/\s/g, "").length > 0 && beneficiaryABN.replace(/\s/g, "").length === 11;
        });
    }
    return yup.string().nullable().notRequired();
});
const tfnSchema = yup.lazy((value) => {
    if (value && value.length > 0) {
        return yup
            .string()
            .trim()
            .matches(/^[0-9\s]*$/, "TFN should contain only digits")
            .test("tfn", "TFN should be 8 or 9 digits.", (tfn) => {
            if (tfn.replace(/\s/g, "").length === 0)
                return true;
            return ((tfn.replace(/\s/g, "").length > 0 && tfn.replace(/\s/g, "").length === 9) ||
                (tfn.replace(/\s/g, "").length > 0 && tfn.replace(/\s/g, "").length === 8));
        });
    }
    return yup.string().nullable().notRequired();
});
const investorTypeSchema = yup
    .string()
    .nullable()
    .oneOf([enums_1.InvestorType.CROWD_SOURCED, enums_1.InvestorType.EMPLOYEE, enums_1.InvestorType.RETAIL, enums_1.InvestorType.SOPHISTICATED, null], "Please select Investor type");
exports.ShareholderSchema = yup.object().shape({
    beneficialOwner: yup.boolean().nullable(),
    isTrustOrSMSF: yup.boolean().nullable(),
    investorType: investorTypeSchema,
    legalEntityName: yup.string(),
    owners: yup.array().of(yup.object().shape({
        firstName: yup.string().trim(),
        middleName: yup.string().trim(),
        lastName: yup.string().trim(),
        address: yup.object().shape(Object.assign({}, MyStakeAddress_1.MyStakeAddressSchema)),
        asicCompanyIdentifier: yup.string().trim(),
        companyName: yup.string().trim(),
        tfn: yup.string().nullable(),
    })),
    entityType: yup
        .string()
        .oneOf([mystake_common_sdk_1.OwnerType.JOINT, mystake_common_sdk_1.OwnerType.INDIVIDUAL, mystake_common_sdk_1.OwnerType.COMPANY])
        .required("Please select an Owner type"),
    beneficiary: yup.array().of(yup.object().shape({
        name: yup.string().trim().max(255),
        abn: beneficiaryABNSchema,
    })),
    contacts: yup.array().of(yup.object().shape(Object.assign({}, Contact_1.ContactSchemaV2))),
    firstInvestedDate: yup.date().nullable().default(null),
});
exports.ShareholderFormSchema = yup.object().shape({
    isTrustOrSMSF: yup.string().required("Please select trust or SMSF"),
    investorType: investorTypeSchema,
    ownersAddresses: yup.array().of(yup.object().shape(Object.assign({}, MyStakeAddress_1.MyStakeAddressSchema))),
    owners: yup.array().of(yup.object().shape({
        firstName: yup.string().trim().required("Please enter First name"),
        middleName: yup.string().trim(),
        lastName: yup.string().trim().required("Please enter Last name"),
        tfn: tfnSchema,
    })),
    ownerType: yup
        .string()
        .oneOf([mystake_common_sdk_1.OwnerType.JOINT, mystake_common_sdk_1.OwnerType.INDIVIDUAL, mystake_common_sdk_1.OwnerType.COMPANY])
        .required("Please select an Owner type"),
    beneficiaryName: yup.string().trim().max(255),
    beneficiaryABN: beneficiaryABNSchema,
    contacts: yup.array().of(yup.object().shape(Object.assign({}, Contact_1.ContactSchemaV2))),
    acn: yup
        .string()
        .trim()
        .when(["isForeignCompany", "investorType"], (isForeignCompany, investorType) => isForeignCompany || investorType !== mystake_common_sdk_1.OwnerType.COMPANY
        ? yup.string()
        : yup
            .string()
            .matches(/^[0-9\s]*$/, "ACN should contain only digits")
            .test("acn", "ACN/ARBN should be 9 digits.", (acn) => acn && acn.replace(/\s/g, "").length > 0 && acn.replace(/\s/g, "").length === 9)),
    companyName: yup.string().trim(),
    isForeignCompany: yup.boolean(),
    companyTfn: tfnSchema,
});
exports.ShareholderEditFormSchema = yup.object().shape({
    investorType: yup
        .string()
        .nullable()
        .oneOf([enums_1.InvestorType.CROWD_SOURCED, enums_1.InvestorType.EMPLOYEE, enums_1.InvestorType.RETAIL, enums_1.InvestorType.SOPHISTICATED, null])
        .when(["$isInvestor"], (isInvestor) => isInvestor ? yup.string().nullable() : yup.string().nullable().required("Please select Investor type")),
    ownersAddresses: yup.array().of(yup.object().shape(Object.assign({}, MyStakeAddress_1.MyStakeAddressSchema))),
    owners: yup.array().of(yup.object().shape({
        tfn: tfnSchema,
    })),
    beneficiaryName: yup.string().trim().max(255),
    beneficiaryABN: beneficiaryABNSchema,
    contacts: yup.array().of(yup.object().shape(Object.assign({}, Contact_1.ContactSchemaV2))),
});
//# sourceMappingURL=IndividualShareholder.js.map